//card component, has header and icon
// a space for 'white' content
//a space for 'gray' content
import React from 'react';
import Envelope from "../../../images/envelope.png";
import ActionButton from '../../core/components/ActionButton'; // Assuming ActionButton is already refactored or doesn't use AntD

const CBCard = ({ style = {}, type = "normal", title, icon=<img className="mr-2" src={Envelope} alt=""/>, footerContent, onClick, children, rightAction, className = '' }) => { // Added className, alt, and Tailwind margin to icon
return (
  // Replaced Layout with div, added common card styles
  <div
    className={`cb-card-content-frame bg-white border border-gray-200 rounded shadow-md ${className}`} // Apply base styles and passed className
    style={style} // Apply passed inline styles
    onClick={onClick} // Apply onClick if provided
  >
    {/* Replaced Content/Row/Col with divs and flexbox for header */}
    <div className="flex items-center p-4 border-b border-gray-200"> {/* Header area */}
      <div className="flex items-center flex-grow space-x-2 font-sarabun text-lg text-gray-700"> {/* Title area */}
        {icon}
        <span>{title}</span>
      </div>
      {rightAction && <div className="flex-shrink-0">{rightAction}</div>} {/* Action area */}
    </div>

    {/* Replaced Content with div for main children */}
    <div className="p-4"> {/* Main content area */}
      {children}
    </div>

    {/* Replaced Footer div with styled div */}
    {footerContent && (
      <div className="cb-footer bg-gray-50 p-4 border-t border-gray-200 rounded-b"> {/* Footer area */}
       {footerContent}
      </div>
    )}
  </div>
);
}
export { CBCard };